<div class="login-screen">
  <form [formGroup]="signupForm" (ngSubmit)="submit()" class="login-form">
    <fieldset>
      <tngh-form-section title="Account aanmaken" i18n-title="signup@@signupTitle">
        <tngh-form-grid>
          <tngh-text-input
            class="span-6"
            formControlName="email"
            autocapitalize="none"
            label="E-mailadres"
            i18n-label="Label emailaddress@@emailaddress"
            [showFormErrors]="showFormErrors"
          />
          <tngh-text-input
            class="span-6"
            formControlName="name"
            autocapitalize="words"
            label="Voornaam"
            i18n-label="Label name@@name"
            [showFormErrors]="showFormErrors"
          />
          <tngh-text-input
            class="span-6"
            formControlName="surname"
            autocapitalize="words"
            label="Achternaam"
            i18n-label="Label surname@@surname"
            [showFormErrors]="showFormErrors"
          />
        </tngh-form-grid>
      </tngh-form-section>
    </fieldset>
    @if (hasTermsOrPrivacy()) {
      <div class="terms">
        <tngh-checkbox formControlName="termsAndConditions" variant="tablet" />
        <span
          >Door een account aan te maken ga je akkoord met onze
          @if (otpConfig()?.privacyPolicy && otpConfig()?.liabilityDisclaimer) {
            <a
              [href]="$safeNavigationMigration(otpConfig()?.privacyPolicy!.url)"
              [download]="$safeNavigationMigration(otpConfig()?.privacyPolicy!.downloadFilename)"
              target="_blank"
              >privacyverklaring</a
            >
            en
            <a
              [href]="$safeNavigationMigration(otpConfig()?.liabilityDisclaimer!.url)"
              [download]="$safeNavigationMigration(otpConfig()?.liabilityDisclaimer!.downloadFilename)"
              target="_blank"
              >aansprakelijkheidsbeperking</a
            >.
          } @else if (otpConfig()?.privacyPolicy) {
            <a
              [href]="$safeNavigationMigration(otpConfig()?.privacyPolicy!.url)"
              [download]="$safeNavigationMigration(otpConfig()?.privacyPolicy!.downloadFilename)"
              target="_blank"
              >privacyverklaring</a
            >.
          } @else if (otpConfig()?.liabilityDisclaimer) {
            <a
              [href]="$safeNavigationMigration(otpConfig()?.liabilityDisclaimer!.url)"
              [download]="$safeNavigationMigration(otpConfig()?.liabilityDisclaimer!.downloadFilename)"
              target="_blank"
              >aansprakelijkheidsbeperking</a
            >.
          }
        </span>
      </div>
    }
    <div class="login-screen__cta">
      <tngh-button
        i18n-label="signup button|signup confirmation, sends the form@@signupButton"
        label="Maak account aan"
        [fullwidth]="true"
        [disabled]="!signupForm.valid"
        type="submit"
        class="login-form__btn"
      />
    </div>
  </form>
</div>
